import type { GatewayBrowserClient } from "../gateway.ts";

export type FlociAgentRecord = {
  id: string;
  label?: string;
  status?: string;
};

export type FlociAgentsResult = {
  ok: boolean;
  source: "floci" | "unavailable";
  fetchedAt: number;
  agents: FlociAgentRecord[];
  error?: string;
};

export async function loadFlociAgents(
  client: GatewayBrowserClient | null,
  connected: boolean,
): Promise<FlociAgentsResult | null> {
  if (!client || !connected) {
    return null;
  }
  try {
    return await client.request<FlociAgentsResult>("floci.agents", { timeoutMs: 2500 });
  } catch {
    return {
      ok: false,
      source: "unavailable",
      fetchedAt: Date.now(),
      agents: [],
      error: "floci.agents failed",
    };
  }
}
